import React, { useContext, useEffect } from 'react'
import { FaFire, FaGamepad, FaStar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { DataContext } from '../../Context/DataContext'

const FirstSection = () => {
  const gameData = useContext(DataContext)

useEffect(() => {
  const loadAOS = async () => {
    const AOS = await import('aos');
    AOS.init({
      duration: 500,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  };
  loadAOS();
}, []);

  return (
    <section
      className="relative lg:px-8 overflow-hidden bg-gradient-to-br from-[#0f172a] via-[#0a0f1f] to-[#020617]"
    >
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "radial-gradient(circle at 20% 40%, rgba(56,189,248,0.15), transparent 40%), radial-gradient(circle at 80% 60%, rgba(59,130,246,0.15), transparent 40%), radial-gradient(circle at 50% 90%, rgba(236,72,153,0.12), transparent 40%)",
          }}
        ></div>
      </div>

      <div
        className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lg:pt-20 sm:pt-16 pt-10 lg:pb-24 pb-[55px] text-center"
      >
        <div data-aos="zoom-in" data-aos-delay="100" className="inline-flex items-center px-6 cursor-pointer py-2.5 bg-white/5 border border-cyan-400/30 rounded-full text-cyan-300 text-sm font-medium mb-10 backdrop-blur-sm shadow-[0_0_20px_rgba(56,189,248,0.25)] hover:shadow-[0_0_40px_rgba(56,189,248,0.45)] transition">
          <FaGamepad className="w-4 h-4 mr-2 text-cyan-400" />
            Welcome to Game Zone Hub
          <FaFire className="w-4 h-4 ml-2 text-orange-400 animate-pulse" />
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-400 drop-shadow-[0_0_20px_rgba(59,130,246,0.45)]">
          Play Free <span className="text-white">Online Games</span> Instantly
        </h1>

        {/* 🚀 NATURAL HERO DESCRIPTION FOR HIGH VALUE CONTENT */}
        <p className="mt-8 max-w-4xl mx-auto text-gray-300 sm:text-lg md:text-xl leading-relaxed font-light">
          Welcome to Game Zone Hub, your new favorite spot to <strong>play free online games</strong>. We have put together a huge collection of fun <strong>HTML5 browser games</strong> that you can play right away. Whether you love fast-paced racing games, challenging logic puzzles, or action-packed multiplayer battles, we have got you covered. The best part? You don't need to download anything, sign up for an account, or pay any hidden fees. Just pick a game and start having fun!
        </p>

        {gameData?.length > 0 && (
          <div data-aos="fade-up" data-aos-delay="200" className="sm:mt-14 mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="bg-white/5 cursor-pointer backdrop-blur-md p-6 rounded-2xl border border-white/10 hover:border-cyan-400/40 shadow-lg hover:shadow-[0_0_30px_rgba(56,189,248,0.35)] transition transform hover:-translate-y-1">
              <div className="xl:text-4xl lg:text-3xl md:text-3xl sm:text-2xl text-xl font-bold text-white">
                {gameData?.length - 1}+
              </div>
              <div className="mt-2 text-sm tracking-wide text-cyan-300 font-semibold uppercase">
                Premium Browser Games
              </div>
            </div>

            <div className="bg-white/5 cursor-pointer backdrop-blur-md p-6 rounded-2xl border border-white/10 hover:border-yellow-400/40 shadow-lg hover:shadow-[0_0_30px_rgba(250,204,21,0.35)] transition transform hover:-translate-y-1">
              <div className="flex items-center justify-center xl:text-4xl lg:text-3xl md:text-3xl sm:text-2xl text-xl font-bold text-white">
                100%
                <FaStar className="ml-2 text-yellow-400 w-7 h-7 drop-shadow-[0_0_10px_rgba(250,204,21,0.6)]" />
              </div>
              <div className="mt-2 text-sm tracking-wide text-yellow-300 font-semibold uppercase">
                Free to Play Forever
              </div>
            </div>
          </div>
        )}

        <div data-aos="fade-up" data-aos-delay="100" className="mt-12 flex flex-wrap justify-center gap-5">
          <Link
            to="/games"
            className="px-8 py-4 rounded-xl bg-gradient-to-r from-cyan-500 to-blue-600 text-white font-bold text-lg shadow-[0_0_20px_rgba(59,130,246,0.4)] hover:shadow-[0_0_40px_rgba(56,189,248,0.6)] transition transform hover:scale-105"
          >
            Start Playing Now
          </Link>
          
          <Link
            to="/games"
            className="px-8 py-4 rounded-xl bg-white/5 border border-white/20 text-gray-200 font-bold text-lg hover:bg-white/10 hover:border-cyan-400/50 hover:text-white transition transform hover:scale-105"
          >
            Explore All Categories
          </Link>
        </div>

        {/* 🚀 NATURAL 'WHY PLAY' SECTION FOR SEO DEPTH */}
        <div className="md:mt-20 mt-16 border-t border-white/10 pt-12 max-w-5xl mx-auto text-center" data-aos="fade-up">
            <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-extrabold text-white mb-6">Why Play at Game Zone Hub?</h2>
            <div className="text-gray-400 text-base leading-relaxed space-y-4 text-justify sm:text-center">
                <p>
                    We know that gamers want things to be fast and easy. That is why we use the latest <strong>HTML5 technology</strong> to make sure every game loads quickly and runs smoothly right in your web browser. You don't have to worry about running out of storage space on your phone or accidentally downloading viruses from shady websites. Our platform is safe, secure, and built for performance.
                </p>
                <p>
                    Plus, you can play our games almost anywhere. You can start a tricky puzzle game on your laptop at home, and then play a fun arcade game on your mobile phone while you are waiting for the bus. The site automatically adjusts so it looks great on any screen size. We are constantly adding new top-rated games to our collection, so you will always find something new to play. Just find a game you like, click play, and jump into the action!
                </p>
            </div>
        </div>

      </div>
    </section>
  )
}

export default FirstSection